// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerSignInStyles } from "@steiner/Overrides/Widgets/Common/HeaderSignIn";
import Account from "@steiner/XDL/Icons/Account";
import SignIn from "@steiner/XDL/Icons/SignIn";
import { css } from "styled-components";

headerSignInStyles.signInHeaderClickable = {
    icon: {
        src: SignIn,
    },
};

headerSignInStyles.myAccountHeaderClickable = {
    icon: {
        src: Account,
    },
};

headerSignInStyles.floatingTooltipSignIn = {
    tooltipContent: {
        css: css`
            border-radius: 0;
            padding: 0;
            max-width: 317px;
        `,
    },
    tooltipArrow: {
        width: 12,
        height: 8,
    },
};

headerSignInStyles.floatingTooltipMyAccount = {
    tooltipContent: {
        css: css`
            border-radius: 0;
            padding: 0;
            max-width: 485px;
        `,
    },
    tooltipArrow: {
        width: 12,
        height: 8,
    },
};
